import React from 'react';
import { Navbar } from 'react-bootstrap';
import { Link, IndexLink } from 'react-router';
import './ProductMainEdit.less';


class ProductMainEditHome extends React.Component {

   render() {
      const { productId } = this.props.params;
      return (
         <div>
            <Navbar>
               <ul className="nav navbar-nav" >
                  <li>
                     <IndexLink to={`/product/productMain/edit/${productId}`} activeStyle={{ color: 'red' }} >General
                     </IndexLink>
                  </li>
                  <li>
                     <Link to={`/product/productMain/edit/${productId}/price`}
                           activeStyle={{ color: 'red' }} >Price</Link>
                  </li>
                  <li>
                     <Link to={`/product/productMain/edit/${productId}/location`}
                           activeStyle={{ color: 'red' }} >Locations</Link>
                  </li>
                  <li>
                     <Link to={`/product/productMain/edit/${productId}/feature`}
                           activeStyle={{ color: 'red' }} >Features</Link>
                  </li>
                  <li>
                     <Link to={`/product/productMain/edit/${productId}/image`}
                           activeStyle={{ color: 'red' }} >Images</Link>
                  </li>
               </ul>
            </Navbar>
            {this.props.children}
         </div>
      )
         ;
   }
}
ProductMainEditHome.propTypes = {
   children: React.PropTypes.object,
   params: React.PropTypes.object
};

export default ProductMainEditHome;



/** WEBPACK FOOTER **
 ** ./src/components/ItemManagement/Product/ProductMain/ProductMainEdit/ProductMainEdit.js
 **/